import React from 'react';
import Select from 'react-select';

export class ProductGroupSelection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedProductGroups: null,
      isModified: false,
    };
  }

  onProductGropupSelection = (event) => {
    this.props.onProductGroupSelection(event);
  };

  render() {
    const { selectedProductGroups, productGroupOptions } = this.props;

    return (
      <Select
        options={productGroupOptions}
        defaultValue={selectedProductGroups}
        onChange={this.onProductGropupSelection}
        placeholder={'Select product groups'}
        isMulti
        isDisabled={this.props.disabled}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/config_central/pl_gl_mapping/product_group_selection.jsx